export default function InferredEditedIco() {
  return (
    <svg
      width="6"
      height="14"
      viewBox="0 0 6 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="3"
        cy="3"
        r="3"
        transform="matrix(1 0 0 -1 0 6)"
        fill="#049F9A"
      />
      <circle
        cx="3"
        cy="3"
        r="3"
        transform="matrix(1 0 0 -1 0 14)"
        fill="#0070F2"
      />
    </svg>
  );
}
